import _ from 'lodash';

export type BuildQueryParamLinkQueryParams =
  | {
      [key: string]: string | number | boolean | string[] | number[];
    }
  | any;

export const getHashFromUrl = (): string => {
  const fullHash = window.location.hash;
  // hash could be like #integrations?success=true and we just want "integrations"
  const locationOfQuery = _.indexOf(fullHash, '?');
  if (locationOfQuery > -1) {
    return fullHash.slice(1, locationOfQuery);
  } else {
    return fullHash.replace('#', '');
  }
};

export const updateHash = (newHash: string): void => {
  if (history.pushState) {
    history.pushState(null, null, `#${newHash}`);
  } else {
    location.hash = `#${newHash}`;
  }
};

export const buildQueryParamLink = (
  url: string,
  queryParams: BuildQueryParamLinkQueryParams,
  allowFalseyQueryParamValues: boolean = false
): string => {
  const queryParamStr = _.chain(_.keys(queryParams))
    .filter((x) => allowFalseyQueryParamValues || !!queryParams[x])
    .flatMap((x) => {
      let result;
      const value = queryParams[x];
      if (_.isArray(value)) {
        result = _.map(value, (val) => {
          return { param: x, value: val };
        });
      } else {
        result = [{ param: x, value }];
      }
      return result;
    })
    .map((x) => `${x.param}=${encodeURIComponent(x.value)}`)
    .join('&')
    .value();
  return queryParamStr ? `${url}?${queryParamStr}` : url;
};
